import { render } from "./MainFeed.vue?vue&type=template&id=20f1e930&scoped=true"
import script from "@/wwwroot/js/mainFeed.js?vue&type=script&lang=js"
export * from "@/wwwroot/js/mainFeed.js?vue&type=script&lang=js"

import "@/wwwroot/css/mainFeed.css?vue&type=style&index=0&id=20f1e930&scoped=true&lang=css"
import "@/wwwroot/css/sharedStyles.css?vue&type=style&index=1&id=20f1e930&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20f1e930"]])

export default __exports__